import styled, { keyframes } from 'styled-components';
import { shade } from 'polished';
import ImgLogin from '../../assets/sign-up-background.png';

export const Container = styled.div`
  /**Tem 100% da parte visível da tela que o usuário consegue ver */
  height: auto;
  /**Faz os items de dentro ficar todos um do lado do outro. */
  display: flex;
  /**Faz os items de dentro ter o mesmo tamanho, no caso, o tamanho de
    100vh */
  align-items: stretch;
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),
    url(${ImgLogin}) no-repeat center;//url(${ImgLogin}) no-repeat center;
  background-size: cover;
  overflow-x: hidden;
`;

const appearFromRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(70px);
  }
  to{
    opacity: 1;
    transform: translateX(0);
  }
`;

export const Content = styled.div`
  display: flex;
  justify-self: center;
  flex-direction: column;
  //justify-content: center;
  width: 100%;
  max-width: auto;
  min-height: 100vh;
`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;

  animation: ${appearFromRight} 1s;

  img {
    margin-top: 20px;
    //margin-right: 30px;
    width: 290px;
    height: 200px;
  }

  ::placeholder {
    font-family: 'Montserrat';
  }

  form {
    //margin: 49px 0;
    width: 340px;
    height: 100%;
    h1 {
      font-weight: bold;
    }

    a {
      color: #f4ede8;
      display: block;
      margin-top: 14px;
      text-decoration: none;
      transition: color 0.2s;

      &:hover {
        color: ${shade(0.2, '#f4ede8')};
      }
    }
  }

  > a {
    color: #fff;
    display: block;
    text-decoration: none;
    transition: color 0.2s;
    margin-top: 24px;
    margin-bottom: 20px;
    font-family: 'Roboto', sans-serif;
    svg {
      margin-right: 8px;
    }

    &:hover {
      color: ${shade(0.2, '#fff')};
    }

    display: flex;
    align-items: center;
  }
  /**Ele estiliza apenas o 'a' que estar dentro do content. Assim, ele não
  sobrescreve nenhuma estilização de quaisquer outro 'a' que esteja em outro
  componente. */
`;

export const HeaderInput = styled.h1`
  color: #2f2f2f;
  font-size: 16px !important;
  font-weight: 400;
  margin-top: 5px;
`;
